import { render, staticRenderFns } from "./dataRoleTableU.vue?vue&type=template&id=46175840&scoped=true"
import script from "./dataRoleTableU.vue?vue&type=script&lang=js"
export * from "./dataRoleTableU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46175840",
  null
  
)

export default component.exports